import React from 'react';
import { IProps } from './types';

/** 修改會員資料提示頁 */
const maintainComplete:React.FC<IProps> = (props) => {
  return (
    <div className="member-verify-complete auth-block">
      <div className="auth-block__row">
        <div className="auth-block__complete-icon" />
      </div>
      <div className="auth-block__row">
        <p className="auth-block__info-title">修改完成</p>
      </div>
      <div className="auth-block__row">
        <p className="auth-block__part">歡迎使用旺旺友聯網路投保系統</p>
      </div>
      <div className="auth-block__row">
        <span className="element__button element__button--red" onClick={props.onSubmit}>確認並前往</span>
      </div>
    </div>
  );
};

export default maintainComplete;
